import { render, staticRenderFns } from "./input-number.vue?vue&type=template&id=1f12f26e&scoped=true"
import script from "./input-number.ts?vue&type=script&lang=ts&external"
export * from "./input-number.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f12f26e",
  null
  
)

export default component.exports